import { agentProfileIdSchema } from "./profile.js";
import * as z$1 from "zod/v4";
//#region src/schemas/protocol/core-readiness-facts-changed.ts
const CORE_READINESS_FACTS_CHANGED_MARKER_KIND = "core_readiness_facts_changed";
const coreReadinessFactsChangedSchema = z$1.strictObject({
	agentProfileId: agentProfileIdSchema,
	kind: z$1.literal(CORE_READINESS_FACTS_CHANGED_MARKER_KIND)
});
//#endregion
export { CORE_READINESS_FACTS_CHANGED_MARKER_KIND, coreReadinessFactsChangedSchema };

//# sourceMappingURL=core-readiness-facts-changed.js.map